import { createFileRoute } from '@tanstack/react-router';
import { useHasPermission } from '@/hooks/usePermissions';
import { WebhookSubscriptionsPanel } from '@/components/organisms/settings-webhooks/WebhookSubscriptionsPanel';

export const Route = createFileRoute('/_dashboard/dashboard/settings/webhooks')({
  component: WebhooksRoute,
});

function WebhooksRoute() {
  const canView = useHasPermission('company:view');

  if (!canView) {
    return (
      <div className="max-w-2xl rounded-md border border-amber-200 bg-amber-50 p-6 text-sm text-amber-900">
        You don&apos;t have permission to manage webhooks. Ask an administrator for access.
      </div>
    );
  }

  return <WebhookSubscriptionsPanel />;
}
